import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Page404 from '../../views/user/Auth/Page404';

import {
  // Attendance,
  EditLeaveApplication,
  LeaveApplication,
  MarkAttendance,
  ViewApplications,
  CabinBooking,
} from '../../views/user/EmployeeServices';
import { MentoringBookings } from '../../views/user/EmployeeServices/mentoring/MentoringBookings';
import AttendanceView from '../../views/user/EmployeeServices/Attendance/AttendanceView';
import HolidaysCalendar from '../../views/user/EmployeeServices/Holidays/HolidaysCalendar';
import Food from '../../views/user/EmployeeServices/Food/Food';
import CompensatoryWorkRequest from '../../views/user/EmployeeServices/CompensatoryWork/CompensatoryWorkRequest';
import PostWorking from '../../views/user/EmployeeServices/PostWorkingHours/PostWorking';
import TransportationView from '../../views/user/EmployeeServices/Transportation/TransportationView';
import RequirementView from '../../views/user/EmployeeServices/Requirement/RequirementView';
import GrandRequest from '../../views/user/EmployeeServices/leave/GrandRequest';
import AttendanceRegularization from '../../views/hr/myworkspace/AttendanceRegularization';
import RegularizationRequest from '../../views/hr/myworkspace/RegularizationRequest';
import HrPolicy from '../../views/user/EmployeeServices/HrPolicy/HrPolicy';
import LeaveGrantApplications from '../../views/user/EmployeeServices/leave/ViewGrantApplications';
import EmployeeLms from '../../views/user/EmployeeServices/LMS/EmployeeLms';

const EmployeeServiceRouter = () => {
  return (
    <Routes>
      <Route path="attendance" element={<AttendanceView />} />
      <Route path="leave" element={<ViewApplications />} />
      <Route path="applications" element={<LeaveApplication />} />
      <Route path="edit-leave-application/:id" element={<EditLeaveApplication />} />
      <Route path="markattendance" element={<MarkAttendance />} />
      <Route path="compensatory-work-request" element={<CompensatoryWorkRequest />} />

      <Route path="mentoring-bookings" element={<MentoringBookings />} />
      <Route path="holidays-calendar" element={<HolidaysCalendar />} />
      <Route path="food" element={<Food />} />
      <Route path="postWorking" element={<PostWorking />} />
      <Route path="transportation" element={<TransportationView />} />
      <Route path="requirement" element={<RequirementView />} />
      <Route path="grant-request" element={<GrandRequest />} />
      <Route path="leave-grant-requests" element={<LeaveGrantApplications />} />
      {/* Attendance Regularizations*/}
      <Route path="attendance-regularization" element={<AttendanceRegularization />} />
      <Route path="attendance-regularization/request" element={<RegularizationRequest />} />
      <Route path="hr-policy" element={<HrPolicy />} />
      <Route path="employee-lms" element={<EmployeeLms />} />
      <Route path="*" element={<Page404 />} />
    </Routes>
  );
};

export default EmployeeServiceRouter;
